import * as types from './actionTypes';
import { axios } from '../utils/api/axiosConfig';

const apiRoutes = require('../utils/api/apiRouteConfig');

export const bindDESQuoteToList = (updatedCasesList) => (dispatch) => {
    dispatch({
        type: types.RECEIVE_NEW_BUSINESS_CASE,
        payload: updatedCasesList,
    });
}

const getNewBusinessCase = (args) => (dispatch) => {
    let userType = '';

    if(args.userType){
        userType = args.userType;
    }

    let pageNo;
    if (args.skip && args.filter && args.filter.length > 0) {
        pageNo = Math.ceil(args.skip/20);
    } else if (args.skip) {
        pageNo = Math.ceil((args.skip / 20));
    } else {
        pageNo = 1;
    }

    const url = `${apiRoutes.quickQuotes}/get-nb-cases`;
    const platform = args.platform && args.platform === 'PRIME' ? 'PRIME': 'CIRRUS';
    const payload = {
        userName: args.userName,
        platform,
        userType,
    };

    if (args.pcisId && args.pcisId !== '') {
        payload.pcisId = args.pcisId;
    }

    let dispatchType = "";

    if(args.dateLimit)
    {
        payload.dateLimit = args.dateLimit;
        dispatchType = types.RECEIVE_NEW_BUSINESS_CASE
    }else if (args.filter) {
        let urlParameters = args.filter
        urlParameters.forEach((filter) => {
            payload[filter.id] = filter.value;
        });
        payload.skip = pageNo;
        payload.limit = args.limit;
        dispatchType = types.RECEIVE_NEW_BUSINESS_CASE_RANGE
    }
    else if (args.skip==20) {
        payload.skip = pageNo;
        payload.limit = args.limit;
        dispatchType = types.RECEIVE_NEW_BUSINESS_CASE
    }
    else {
        payload.skip = pageNo;
        payload.limit = args.limit;
        dispatchType = types.RECEIVE_NEW_BUSINESS_CASE_RANGE
    
    }
    dispatch({
        type: types.REQUEST_NEW_BUSINESS_CASE,
    });

    axios.post(url, payload)
        .then((res) => {
            dispatch({
                type: dispatchType,
                payload: res.data,
            });
        })
        .catch((err) => {
            if (err.response) {
                dispatch({
                    type: types.ERROR_NEW_BUSINESS_CASE,
                    payload: err.response.data.message,
                });
            }
        });
};

export default getNewBusinessCase;
